import templateUrl from 'emun.salesrep/market-list.htm'
import MarketPrompt from 'emun.salesrep/market-prompt'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import $session from 'servicestack/session'
import resolve from 'ioc/resolve'
import ServiceBus from "servicestack/service-bus";
import modals from 'webmodals/modals'


class MarketListController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
        $ctrl.bus = new ServiceBus();
        let $rootScope = resolve('$rootScope');
		$rootScope.$on('$marketSubmitted', () => $ctrl.query.load(true));
    }
    $onInit(){
        const $ctrl = this;

        $ctrl.query = new AutoQuery({
            url: 'QueryMarketDates.json?GroupBy=Market,Year',
            hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
			orderBy: 'Market',
            sortOptions:{
				'Market': 'Market: A to Z',
				'-Market': 'Market: Z to A'
            },
          autoLoad: true,
            take: 100,
            pageSize: 12
        });
    }
    load(){
        const $ctrl = this;
        $ctrl.query.load(true);
    }
    create(){
        const $ctrl = this;
		MarketPrompt.open({}).then(() => $ctrl.load());
    }
    view(market){
        const $ctrl = this;
        MarketPrompt.open({marketName: market.market, year: market.year}).then(() => $ctrl.query.load());
    }
    delete(market) {
        const $ctrl = this;
        return modals.confirm("Are you sure?", "Delete Market").result.then(function () {
            $ctrl.bus.send('DeleteMarketDates.json?Market=' + market.market).then(() => $ctrl.query.load());
        });
    }
}

export default MarketListController;